module.exports = __webpack_public_path__ + "static/media/C-info.5d6bc5ac.svg";